const formatdate = date =>{
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const minute = date.getMinutes().toString().padStart(2, "0");
  const second = date.getSeconds().toString().padStart(2, "0");
  // console.log(`${year} ${month} ${day}`);

  return `${year} ${month} ${day}`;

};
module.exports= {
  formatdate
}